import * as React from 'react';
import { withRouter, Link, RouteComponentProps } from 'react-router-dom';
import { Button, Card, Col, Divider, Modal, notification, Row, Table } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

import CurrenciesQuery from '../../components/Query/Currencies';
import CurrencyDetail from './CurrencyDetail';
import { Title } from '../../components/Layout/components';
import NotFoundPage from '../NotFound/NotFound';

interface ICurrenciesTableProps extends RouteComponentProps {
  domain: string;
  currencyId?: string;
}

class CurrencyTable extends React.Component<ICurrenciesTableProps> {

  public componentDidMount() {
    if ((this.props as any).onCollapse) {
      (this.props as any).onCollapse(false);
    }
  }

  public render() {
    return (
      <Row>
        <Col span={24}>
          <CurrenciesQuery>
            {({ currencies, createCurrency, updateCurrency, deleteCurrency }: any) => {
              return this.renderData(
                currencies,
                createCurrency,
                updateCurrency,
                deleteCurrency,
                currencies.refetch
              );
            }}
          </CurrenciesQuery>
        </Col>
      </Row>
    );
  }

  private renderData(
    currencies: any,
    createCurrency: Function,
    updateCurrency: Function,
    deleteCurrency: Function,
    refetch: Function
  ) {
    if (currencies && !currencies.loading) {

      // formulář
      if (this.props && this.props.currencyId) {
        const selectedDeliveryMethod = currencies.currencies.find((s: GQL.IStore) => s.id === this.props.currencyId) || undefined;
        if (this.props.currencyId !== 'new' && !selectedDeliveryMethod) {
          return <NotFoundPage domain={this.props.domain} />
        }

        return (
          <CurrencyDetail
            domain={this.props.domain}
            languages={currencies.languages}
            currency={currencies.currencies.find((s: GQL.IStore) => s.id === this.props.currencyId) || undefined}
            currencyList={currencies.currencies}
            onSave={a => this.upsert(a, createCurrency, updateCurrency, refetch)}
            onCancel={() => this.cancel()}
          />
        );
      }

      return (
        <div>
          <Title>Currency</Title>
          <Divider />
          <Link className="ant-btn" to={this.getLink('new')}>
            {`Create ${currencies.currencies.length === 0 ? 'primary' : 'new'} currency`}
          </Link>
          <Table
            rowKey={(record: any) => record.id}
            dataSource={currencies.currencies}
            defaultExpandAllRows={true}
            style={{ marginTop: '20px' }}
          >
            <Table.Column
              title="Value"
              dataIndex="value"
              key="value"
            />
            <Table.Column
              title="Exchange rate to primary currency"
              dataIndex="exchangeRate"
              key="exchangeRate"
              width={120}
              align="center"
            />
            <Table.Column
              title="Primary"
              dataIndex="primary"
              key="primary"
              width={100}
              align="center"
              render={(u, row: GQL.ICurrency) => {
                return (
                  <span>
                    {row.primary ? (
                      <CheckOutlined style={{ color: '#52c41a', fontSize: 20 }} />
                    ) : (
                        <CloseOutlined style={{ fontSize: 20 }} />
                      )}
                  </span>
                );
              }}
            />
            <Table.Column
              width={180}
              title="Actions"
              dataIndex="actions"
              key="actions"
              align="center"
              render={(u: any, row: any) => this.renderActions(u, row, deleteCurrency, refetch)}
            />
          </Table>
        </div>
      );
    }

    return (
      <div>
        <Divider />
        <Card loading={true} title="Loading currencies ..." style={{ width: '100%' }} />
      </div>
    );
  }

  private renderActions(
    u: any,
    currency: GQL.ICurrency,
    deleteCurrency: Function,
    refetch: Function
  ) {
    return (
      <div>
        <Link className="ant-btn" type={'dashed'} to={this.getLink(currency.id)}>
          Edit
        </Link>
        <Divider type={'vertical'} />
        <Button danger={true} onClick={() => this.delete(currency, deleteCurrency, refetch)}>
          Delete
        </Button>
      </div>
    );
  }

  private delete(currency: GQL.ICurrency, deleteCurrency: Function, refetch: Function) {
    Modal.confirm({
      title: `Delete ${currency.value}?`,
      content: (
        <span>
          Are you sure you want to delete currency <strong>{currency.value}</strong>
        </span>
      ),
      onOk: () => {
        return deleteCurrency({
          variables: {
            id: currency.id
          }
        }).then(() => refetch());
      }
    });
  }

  private upsert(
    currency: GQL.ICurrency,
    createCurrency: Function,
    updateCurrency: Function,
    refetch: Function
  ) {
    if (currency != undefined) {
      const variables = {
        id: currency.id,
        currency: {
          value: currency.value,
          exchangeRate: currency.exchangeRate,
        }
      };

      if (currency.id) {
        return updateCurrency({ variables })
          .then(() => refetch())
          .then(() => this.cancel())
          .then(() =>
            notification['success']({
              message: 'Info',
              description: `Currency "${variables.currency.value}" has been updated.`
            })
          );
      }

      createCurrency({ variables })
        .then(() => refetch())
        .then(() => this.cancel())
        .then(() =>
          notification['success']({
            message: 'Info',
            description: `Currency "${variables.currency.value}" has been created.`
          })
        );
    }
  }

  private getLink(recordId: string | null) {
    return `/${this.props.domain}/application/${recordId ? `currency/${recordId}` : 'currency'}`;
  }

  private cancel() {
    this.props.history.push(this.getLink(null));
  }
}

export default withRouter(CurrencyTable);


// WEBPACK FOOTER //
// ./src/scenes/Currencies/CurrenciesTable.tsx